export interface Industry {
  value: string;
  label: string;
  naics: string;
  children?: Industry[];
}

export const INDUSTRIES: Industry[] = [
  {
    value: "construction", label: "Construction", naics: "23",
    children: [
      { value: "construction.residential", label: "Residential Building", naics: "2361" },
      { value: "construction.commercial", label: "Commercial Building", naics: "2362" },
      { value: "construction.civil", label: "Heavy & Civil Engineering", naics: "237" },
      { value: "construction.specialty", label: "Specialty Trade Contractors", naics: "238" },
    ],
  },
  {
    value: "professional-services", label: "Professional Services", naics: "54",
    children: [
      { value: "professional-services.legal", label: "Legal Services", naics: "5411" },
      { value: "professional-services.accounting", label: "Accounting & Bookkeeping", naics: "5412" },
      { value: "professional-services.consulting", label: "Management Consulting", naics: "5416" },
      { value: "professional-services.architecture", label: "Architecture & Engineering", naics: "5413" },
      { value: "professional-services.design", label: "Specialized Design", naics: "5414" },
      { value: "professional-services.marketing", label: "Advertising & Marketing", naics: "5418" },
      { value: "professional-services.other", label: "Other Professional Services", naics: "5419" },
    ],
  },
  {
    value: "technology", label: "Technology", naics: "5415",
    children: [
      { value: "technology.software", label: "Software & SaaS", naics: "5415" },
      { value: "technology.it-services", label: "IT Services & Consulting", naics: "5415" },
      { value: "technology.data", label: "Data Processing & Hosting", naics: "518" },
      { value: "technology.telecom", label: "Telecommunications", naics: "517" },
    ],
  },
  {
    value: "healthcare", label: "Healthcare", naics: "62",
    children: [
      { value: "healthcare.physician", label: "Physician Offices", naics: "6211" },
      { value: "healthcare.dental", label: "Dental Offices", naics: "6212" },
      { value: "healthcare.clinic", label: "Outpatient Care", naics: "6214" },
      { value: "healthcare.home-health", label: "Home Health Care", naics: "6216" },
      { value: "healthcare.hospital", label: "Hospitals", naics: "622" },
      { value: "healthcare.nursing", label: "Nursing & Residential Care", naics: "623" },
    ],
  },
  {
    value: "real-estate", label: "Real Estate", naics: "53",
    children: [
      { value: "real-estate.brokerage", label: "Real Estate Brokerage", naics: "531" },
      { value: "real-estate.property-mgmt", label: "Property Management", naics: "531" },
      { value: "real-estate.rental", label: "Rental & Leasing", naics: "532" },
    ],
  },
  {
    value: "retail", label: "Retail & E-commerce", naics: "44-45",
    children: [
      { value: "retail.general", label: "General Merchandise", naics: "452" },
      { value: "retail.clothing", label: "Clothing & Accessories", naics: "448" },
      { value: "retail.food-beverage", label: "Food & Beverage Stores", naics: "445" },
      { value: "retail.ecommerce", label: "E-commerce & Nonstore", naics: "454" },
      { value: "retail.auto", label: "Auto Dealers & Parts", naics: "441" },
      { value: "retail.other", label: "Other Retail", naics: "453" },
    ],
  },
  {
    value: "food-service", label: "Food & Restaurant", naics: "722",
    children: [
      { value: "food-service.full-service", label: "Full-Service Restaurant", naics: "7225" },
      { value: "food-service.quick-service", label: "Quick-Service / Fast Food", naics: "7226" },
      { value: "food-service.catering", label: "Catering & Food Services", naics: "7223" },
      { value: "food-service.bar", label: "Bars & Breweries", naics: "7224" },
    ],
  },
  {
    value: "manufacturing", label: "Manufacturing", naics: "31-33",
    children: [
      { value: "manufacturing.food", label: "Food & Beverage", naics: "311" },
      { value: "manufacturing.chemical", label: "Chemical & Pharmaceutical", naics: "325" },
      { value: "manufacturing.metal", label: "Metal & Fabrication", naics: "332" },
      { value: "manufacturing.electronics", label: "Computer & Electronics", naics: "334" },
      { value: "manufacturing.other", label: "Other Manufacturing", naics: "339" },
    ],
  },
  {
    value: "finance", label: "Finance & Insurance", naics: "52",
    children: [
      { value: "finance.banking", label: "Banking & Credit", naics: "521-522" },
      { value: "finance.investments", label: "Securities & Investments", naics: "523" },
      { value: "finance.insurance", label: "Insurance", naics: "524" },
    ],
  },
  {
    value: "transportation", label: "Transportation & Logistics", naics: "48-49",
    children: [
      { value: "transportation.trucking", label: "Trucking & Freight", naics: "484" },
      { value: "transportation.warehouse", label: "Warehousing & Storage", naics: "493" },
      { value: "transportation.courier", label: "Couriers & Delivery", naics: "492" },
      { value: "transportation.passenger", label: "Passenger Transit", naics: "485" },
    ],
  },
  {
    value: "education", label: "Education", naics: "61",
    children: [
      { value: "education.k12", label: "K-12 Schools", naics: "6111" },
      { value: "education.higher", label: "Colleges & Universities", naics: "6113" },
      { value: "education.training", label: "Training & Tutoring", naics: "6116" },
    ],
  },
  {
    value: "hospitality", label: "Hospitality & Lodging", naics: "721",
  },
  {
    value: "arts-entertainment", label: "Arts, Entertainment & Recreation", naics: "71",
  },
  {
    value: "personal-services", label: "Personal Services", naics: "812",
    children: [
      { value: "personal-services.salon", label: "Salons & Spas", naics: "812" },
      { value: "personal-services.fitness", label: "Fitness & Wellness", naics: "713" },
      { value: "personal-services.cleaning", label: "Cleaning & Laundry", naics: "812" },
    ],
  },
  {
    value: "auto-services", label: "Auto Services", naics: "811",
  },
  {
    value: "agriculture", label: "Agriculture & Farming", naics: "11",
  },
  {
    value: "nonprofit", label: "Nonprofit & Religious", naics: "813",
  },
  {
    value: "wholesale", label: "Wholesale Trade", naics: "42",
  },
  {
    value: "other", label: "Other", naics: "81",
  },
];

export function flattenIndustries(): { value: string; label: string; naics: string }[] {
  const result: { value: string; label: string; naics: string }[] = [];
  for (const ind of INDUSTRIES) {
    if (ind.children) {
      for (const child of ind.children) {
        result.push({ value: child.value, label: `${ind.label} > ${child.label}`, naics: child.naics });
      }
    } else {
      result.push({ value: ind.value, label: ind.label, naics: ind.naics });
    }
  }
  return result;
}

export { NAICS_KEYWORD_MAP } from "./bls-industries";

export function detectNaics(businessName: string, keywordMap: Record<string, string>): string | null {
  const lower = businessName.toLowerCase();
  for (const [keyword, naics] of Object.entries(keywordMap)) {
    if (lower.includes(keyword)) return naics;
  }
  return null;
}
